<template>
  <div class="login-wrap">
    <div class="login-left"></div>
    <div class="login-right">
      <div class="login-form">
        <!-- <img src="@/assets/images/loginIcon2.png" /> -->
        <!-- <img src="@/assets/images/loginIcon3.png" /> -->
        <img src="@/assets/images/loginIcon1.png" />
        <template v-if="!showForget">
          <el-form :model="formdata" style="width: 80%; margin: 0 auto">
            <el-form-item>
              <el-input
                v-model="formdata.username"
                placeholder="手机号/邮箱"
                @keyup.enter.native="handleLodin"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="formdata.password"
                placeholder="密码"
                @keyup.enter.native="handleLodin"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item :class="{ 'login-form-btn': true, marginTop: true }">
              <el-button
                type="primary"
                @click="handleLodin()"
                :loading="$store.state.user.loadingState"
                >登 录</el-button
              >
            </el-form-item>
          </el-form>
          <p><span @click="showForget = true">忘记密码?</span></p>
        </template>
        <template v-else>
          <ForgotPassword v-if="showForget" />
          <p><span @click="goBackLogin">返回登录</span></p>
        </template>
      </div>
    </div>
    <div class="copyright">
      <div class="description">
        Copyright © 2023 重庆巨基科技有限公司 版权所有
      </div>
      <a
        class="jumpto"
        href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
        target="_blank"
        rel="noopener noreferrer"
        >渝ICP备14009693号-3</a
      >
    </div>
  </div>
</template>
<script>
import ForgotPassword from "@/components/ForgotPassword";
export default {
  components: {
    ForgotPassword,
  },
  data() {
    return {
      formdata: {
        username: "",
        password: "",
      },
      showForget: false,
    };
  },
  methods: {
    goBackLogin() {
      this.showForget = false;
    },
    handleLodin() {
      this.$store.commit("SET_LATEFLAG", false);
      if (this.formdata.username !== "" && this.formdata.password !== "") {
        let regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
        let regMobile =
          /^(0|86|17951)?[0-9]{11}$/;
        if (
          regEmail.test(this.formdata.username) ||
          regMobile.test(this.formdata.username)
        ) {
          this.$store.commit("SET_LOADING", true);
          this.$store.commit("SET_ROUTE", []);
          this.$store.dispatch("login", this.formdata);
        } else {
          this.$message.error("手机号或者邮箱格式不正确!");
        }
      } else {
        this.$message({
          showClose: true,
          message: "用户名和密码不能为空",
          type: "error",
        });
      }
    },
  },
  mounted() {},
};
</script>
<style scoped lang="scss">
.login-wrap {
  width: 100%;
  height: 100%;
  background: #fff;
  background: url("~@/assets/images/loginbg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  @include setFlexBetween;
  .login-left {
    width: 60%;
    height: 100%;
  }
  .login-right {
    width: 35%;
    height: 45%;
    @include setFlexCenter;
    justify-content: flex-start;
    .login-form {
      background: #fff;
      border-radius: 20px;
      width: 60%;
      // height: 100%;
      @include setFlexColumn;
      img {
        // width: 80%;
        width: 40%;
        margin: 40px auto;
      }
      .login-form-btn {
        .el-button {
          width: 100%;
          background: #28cccb;
          box-shadow: 0px 3px 12px 0px #79d5d5;
          border-radius: 3px;
          border-color: #28cccb;
        }
      }
      .marginTop {
        margin-top: 50px;
      }
      p {
        color: #999;
        text-align: center;
        cursor: default;
        margin-bottom: 35px;
      }
      p:hover {
        color: #28cccb;
      }

      // height: 100%;
      // ::v-deep .el-form-item {
      //   margin-bottom: 37px;
      //   .el-form-item__label {
      //     font-size: 16px;
      //     color: #333;
      //     line-height: 22px;
      //     margin-bottom: 17px;
      //     &::before {
      //       content: "";
      //     }
      //   }
      //   .el-input__inner {
      //     height: 49px;
      //     background-color: #f5f6fa;
      //     color: #1c1c1c;
      //     font-size: 16px;
      //     border: none;
      //   }
      //   input::-webkit-input-placeholder {
      //     color: #888888;
      //   }
      //   input::-moz-input-placeholder {
      //     color: #888888;
      //   }
      //   input::-ms-input-placeholder {
      //     color: #888888;
      //   }
      // }
      // .project-title {
      //   color: #377afd;
      //   font-size: 48px;
      //   font-weight: bolder;
      //   margin-bottom: 60px;
      // }
      // .login-form-btn {
      //   margin-top: 65px;
      //   margin-bottom: 10px;
      //   .el-button {
      //     width: 100%;
      //     border-color: #377afd;
      //     background-color: #377afd;
      //     border-radius: 8px;
      //     padding: 11px 90px;
      //     span {
      //       color: #fff;
      //       font-size: 28px;
      //     }
      //   }
      // }
      // .login-forget-password {
      //   p {
      //     color: #333;
      //     text-decoration: underline;
      //     cursor: pointer;
      //     font-weight: 500;
      //     font-size: 12px;
      //   }
      // }
    }
  }
  .copyright {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 52px;
    background: #02181e;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #bdc2c4;
    line-height: 20px;
    @include setFlexCenter;
    .description {
      width: 340px;
      height: 20px;
    }
    .jumpto {
      color: #bdc2c4;
      margin-left: 28px;
      width: 146px;
      height: 20px;
      cursor: pointer;
    }
    .jumpto:hover {
      color: #fff;
    }
  }
}
</style>
